export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'sdui.app', 'iam.sdui-group.app'],
      appName: 'BiD',
      packageName: 'com.sdui.bid',
      defaultUrl: 'https://sdui.app',
      android: {
        flavor: 'bid'
      },
      ios: {
        Scheme: 'BID'
      }
    }
  }
}
